"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDapiPathName = exports.dapis = exports.dapiManagementMerkleTreeData = exports.api3Contracts = exports.api3ApiIntegrations = void 0;
exports.deriveSponsorWalletAddress = deriveSponsorWalletAddress;
exports.findChainByAlias = findChainByAlias;
exports.getChains = getChains;
const api3ApiIntegrations = __importStar(require("@api3/api-integrations"));
exports.api3ApiIntegrations = api3ApiIntegrations;
const api3Contracts = __importStar(require("@api3/contracts"));
exports.api3Contracts = api3Contracts;
const commons_1 = require("@api3/commons");
const ethers_1 = require("ethers");
const airseeker_json_1 = require("../data/airseeker.json");
const chains_json_1 = __importDefault(require("../data/chains.json"));
const current_hash_json_1 = __importDefault(require("../data/dapi-management-merkle-tree-root/current-hash.json"));
exports.dapiManagementMerkleTreeData = current_hash_json_1.default;
const dapis_json_1 = __importDefault(require("../data/dapis.json"));
const types_1 = require("./types");
const dapis = types_1.DApiElementArraySchema.parse(dapis_json_1.default);
exports.dapis = dapis;
const chains = types_1.ChainElementArraySchema.parse(chains_json_1.default);
function findChainByAlias(alias) {
    const chain = api3Contracts.CHAINS.find((c) => c.alias.toLowerCase() === alias.toLowerCase());
    if (!chain) {
        throw new Error(`Chain with alias ${alias} not found in chains exported by @api3/contracts package`);
    }
    return chain;
}
function getChains() {
    return chains
        .filter((chain) => chain.stage !== 'retired')
        .map((chain) => {
        const { id } = findChainByAlias(chain.alias);
        return { ...chain, id };
    });
}
// Only the slash is replaced, so a name like `sDAI/DAI Exchange Rate` keeps its spaces and needs percent encoding
const getDapiPathName = (dapiName) => dapiName.replace('/', '-');
exports.getDapiPathName = getDapiPathName;
function deriveSponsorWalletAddress(dapiNameInBytes32) {
    const hashedDapiName = ethers_1.ethers.keccak256(dapiNameInBytes32);
    const sponsorAddress = ethers_1.ethers.getAddress(hashedDapiName.slice(0, 42));
    return (0, commons_1.deriveHdNodeFromXpub)(airseeker_json_1.airseekerXPub).derivePath((0, commons_1.deriveWalletPathFromSponsorAddress)(sponsorAddress, commons_1.PROTOCOL_IDS.AIRSEEKER)).address;
}
//# sourceMappingURL=index.js.map